import PrivateLayout from "@/components/layouts/private-layout";
import ViewTeacher from "@/pages/teachers/view-teacher";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated/teachers/$teacherId/")({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <PrivateLayout>
      <ViewTeacher />
    </PrivateLayout>
  );
}
